import { render, staticRenderFns } from "./publish-components.vue?vue&type=template&id=4d18a4a1"
import script from "./publish-components.vue?vue&type=script&lang=js"
export * from "./publish-components.vue?vue&type=script&lang=js"
import style0 from "./publish-components.vue?vue&type=style&index=0&id=4d18a4a1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports